import script from "./all-filters-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./all-filters-button.vue?vue&type=script&setup=true&lang=ts"

import "./all-filters-button.vue?vue&type=style&index=0&id=65f527e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65f527e4"]])

export default __exports__